import { render, staticRenderFns } from "./ActivixHelperNotification.vue?vue&type=template&id=70ba61a4&"
import script from "./ActivixHelperNotification.vue?vue&type=script&lang=js&"
export * from "./ActivixHelperNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports